module.exports = __webpack_public_path__ + "static/india-13f42cfe39666b1f48fddc2d8d660b86.jpg";